import { atom, selector } from 'recoil'

export const userState = atom({
  key: 'user',
  default: {
    id: 0
  }
})
